import React from 'react';
import Container from '@v2/shared/components/Container';
import type { FullLayoutProps } from '@v2/shared/lib/types';

import FooterMenu from './FooterMenu';
import MoneySymbol from './MoneySymbol';
import SiteCopyright from './SiteCopyright';
import ResellerRatingsBadge from './ResellerRatingsBadge';
import AcceptedPaymentMethods from './AcceptedPaymentMethods';

/**
 * headless: apps/topmags/layouts/MainLayout/Footer.
 *
 * The grey is stated here rather than inherited from the page. It used to come for free
 * from Full's background, which now starts at md -- so below md the footer had gone
 * white, where the legacy footer it replaces is #F0F0F0 at every width. Above md this
 * paints the same colour the page already is and changes nothing.
 */
/** The year comes from the layout's props — see `FullLayoutProps['copyrightYear']`. */
type Props = Pick<FullLayoutProps, 'copyrightYear'>;

export default function Footer({ copyrightYear }: Props) {
  return (
    <footer className="py-5 bg-[#F0F0F0]">
      <Container>
        <SiteCopyright year={copyrightYear} />
        <div className="md:items-end md:gap-10 md:flex text-center md:text-left">
          <MoneySymbol />
          <FooterMenu />
          <AcceptedPaymentMethods />
          <ResellerRatingsBadge />
        </div>
      </Container>
    </footer>
  );
}
